import { createAnchor } from '@/api/advertiser'
import MaterialSelect from '@/components/material-select/MaterialSelect.vue'
import moment from 'moment'

export default {
    components: {
        MaterialSelect,
    },
    props: {
        showCreateForm: {
            type: Boolean,
            required: true
        },
        anchorModel: {
            type: Object,
            default: () => ({ })
        }
    },
    created() {
        // console.log('进入数据',this.anchorModel)
        if (this.anchorModel.id) {
            this.actionName = '修改'
        } else {
            this.actionName = '新建'
        }
        //提交的数据
        let advertisers = []
        //需要处理的数据
        let advertisersSelect = []
        let formattedDate = moment().format('MMDD');

        this.anchorModel.advertisers.forEach( (item,index) => {
            //如果有多资产，需要选择
            if (item.apps.length > 1) {
                advertisersSelect.push({id:item.advertiser_id,index: index, advertiser_id:item.out_id, advertiser_name:item.advertiser_name, instance_id: null, path: null, appShow: {}, apps:item.apps})
            } 
            // advertisers.push({id:item.advertiser_id, advertiser_id:item.out_id, advertiser_name:item.advertiser_name, instance_id: item.apps[0].instance_id, path: item.apps[0].path, appShow: item.apps[0], title: item.pts ? formattedDate+''+item.pts[0]['video_name'] : null,})
            advertisers.push({id:item.advertiser_id, advertiser_id:item.out_id, advertiser_name:item.advertiser_name, instance_id: item.apps[0].instance_id, path: item.apps[0].path, appShow: item.apps[0], title: item.pts ? (formattedDate+''+item.pts[0]['video_name'] ).slice(0, 15): null,})

        })

        this.advertisersSelect = advertisersSelect
        this.advertisers = advertisers

        // console.log('this.advertisersSelect',this.advertisersSelect)
        // console.log('this.advertisers',this.advertisers)

        this.anchorModel.icon_images = [
            [],[],[]
        ]

         if (this.anchorModel.iconMaterials && this.anchorModel.iconMaterials.length>0) {
            let array = this.anchorModel.iconMaterials
            let randomIndex = Math.floor(Math.random() * array.length);
            this.icon_image = array[randomIndex];
         }
     },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            actionName: '操作',
            rules: {
                // name: [{ required: true, message: '请填写素材组名称', trigger: 'change' }],
                ios_anchor_title: [{ required: true, message: '请填写iOS锚点入口标题字段', trigger: 'change' }],
                android_anchor_title: [{ required: true, message: '请填写安卓锚点入口标题字段', trigger: 'change' }],
                app_description: [{ required: true, message: '请填写APP详情', trigger: 'change' }],
                guide_text: [{ required: true, message: '请填写引导文案', trigger: 'change' }],
            },
            anchorTypes : [{type:'APP_INTERNET_SERVICE', name:'应用下载-网服'}],
            netServiceTypes : [{type:'MICRO_APP', name:'跳转微信'}],
            advertisers: [],
            advertisersSelect: [],
            icon_image: {},
            appImg1: {},
            appImg2: {},
            appImg3: {},
            appImg4: {},
            appImg5: {},
            appImg6: {},
            anchor_image_mode: 200, //APP图片比例: 100-尺寸为2：1的横图，200-尺寸为3：5的竖图
            appImagesFilters : {},
            appImagesHelp : '',
            result: {
                success: [],
                errors: [],
            },
            showResult: false,
            showSubmit: true,
            getMaterials: [],
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
        this.imageModeChange()
    },
    watch: {},
    methods: {
        changeAppIcon () {

        },
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {
            let error = ''
            this.advertisers.forEach(element => {
                if (!element.path) {
                    error += element.advertiser_id+','
                }
            });

           
            if (error) {
                error = '广告主：' + error + '需要填写小程序和路径'
                return this.$message.error(error)
            }

            if (!this.icon_image.id) {
                return this.$message.error('请选择应用icon')
            }

            this.anchorModel.app_tags = this.anchorModel.app_tags.filter(item => item)
            if (this.anchorModel.app_tags.length < 1) {
                return this.$message.error('请填写APP标签')
            }

            const data = Object.assign({}, this.anchorModel)
            data.icon_images = [this.icon_image]
            data.advertisers = this.advertisers
            data.anchor_image_mode = this.anchor_image_mode

            if (this.anchor_image_mode == 100) {
                if (!this.appImg1.id || !this.appImg2.id || !this.appImg3.id) {
                    return this.$message.error('请上传至少3张APP图片')
                }
                data.app_images = [this.appImg1,this.appImg2,this.appImg3]
            } else {
                if (!this.appImg4.id || !this.appImg5.id || !this.appImg6.id) {
                    return this.$message.error('请上传至少3张APP图片')
                }
                data.app_images = [this.appImg4,this.appImg5,this.appImg6]
            }
           

            // console.log('提交的数据', data)

            this.result.success = []
            this.result.errors = []

            this.loading = true
            createAnchor(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.result = res.data
                    //出现弹窗，提示结果不关闭，关闭弹窗，才刷新
                    this.showResult = true
                    // this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
                this.showSubmit = false
            }).catch(() => {
                this.loading = false
                this.showSubmit = true
            })
        },
        closerResult () {
            this.showResult = false
            this.$emit('success')
            this.close()
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showCreateForm', false)
        },
        clickPane () {
            // console.log(key);
        },
        changeApp (item, option) {
            // console.log(item, option.data.attrs.path, );
            const app = option.data.attrs.app
            const index = option.data.attrs.index
            this.advertisers[index].path = app.path
            this.advertisers[index].appShow = app
        },
        imageModeChange (e) {
            if (e) {
                this.anchor_image_mode = `${e.target.value}`
            }
            if (this.anchor_image_mode == 100) {
                this.appImagesFilters = {type:2,num:1,ratio:2/1,size:5}
                this.appImagesHelp = '请上传最少3张，最多8张大小不超过5M的图片，推荐尺寸280*140px'
            } else {
                this.appImagesFilters = {type:2,num:1,ratio:3/5,size:5}
                this.appImagesHelp = '请上传最少3张，最多8张大小不超过5M的图片，推荐尺寸120*200px'
            }
        },
        changeName(type) {
            // console.log('点击了：', type)
            let name = ''

            if (type === 1) {
                name = "22"
            }
            this.anchorModel.name = name
        }
    }
}
